import {all} from "redux-saga/effects";

// import * as auth from "../app/modules/Auth/_redux/authRedux";

export function* rootSaga() {
  yield all([]);
}
